import type React from 'react';
import { useTenderDetails } from '../../contexts/TenderDetailsContext';
import FinalizeExportStep from './FinalizeExportStep';
import { getLoadingKey } from './utils';
import WorkflowStep from './WorkflowStep';

const CreateDocxStep: React.FC = () => {
  const {
    canManageTender,
    openStep,
    setOpenStep,
    tender,
    validTenderId,
    handleCompileDraft,
    handleDownloadCompile,
    handleResetCompile,
    handleUpdateServiceStatus,
    sectionsCount,
    reviewedSectionsCount,
    loadingStates,
  } = useTenderDetails();

  if (!canManageTender) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={10}
      expanded={openStep === 10}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 10 : null)}
      title="Create and Download DOCX"
      description="Export your finalized proposal."
      isComplete={!!tender.compiledFileLink}
    >
      <FinalizeExportStep
        tenderId={validTenderId}
        onCompile={handleCompileDraft}
        statusObject={tender.compileStatus}
        fileLink={tender.compiledFileLink || tender.draftFileLink}
        onDownload={handleDownloadCompile}
        onReset={handleResetCompile}
        onUpdateStatus={handleUpdateServiceStatus}
        sectionsCount={sectionsCount}
        reviewedSectionsCount={reviewedSectionsCount}
        isDownloading={!!loadingStates[getLoadingKey(validTenderId, 'download', 'final_proposal')]}
      />
    </WorkflowStep>
  );
};

export default CreateDocxStep;
